import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const SubmitAdvanceApplication = gql`
  mutation SubmitAdvanceApplication(
    $idempotencyId: IdempotencyToken!
    $input: SubmitAdvanceApplicationInput!
  ) {
    submitAdvanceApplication(idempotencyId: $idempotencyId, input: $input) {
      __typename
      ... on SubmitAdvanceApplicationSuccess {
        applicationId
      }
      ... on SubmitAdvanceApplicationValidationError {
        ...error
      }
      ... on SubmitAdvanceApplicationMissingAgreement {
        ...error
      }
      ... on SubmitAdvanceApplicationError {
        ...error
      }
      ... on Error {
        ...error
      }
    }
  }
  ${error}
`;
